import { render, staticRenderFns } from "./appAccordion.vue?vue&type=template&id=a670e22a&scoped=true&"
import script from "./appAccordion.vue?vue&type=script&lang=js&"
export * from "./appAccordion.vue?vue&type=script&lang=js&"
import style0 from "./appAccordion.vue?vue&type=style&index=0&id=a670e22a&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a670e22a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/corp-dev.1clicom.ru/laravel/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a670e22a')) {
      api.createRecord('a670e22a', component.options)
    } else {
      api.reload('a670e22a', component.options)
    }
    module.hot.accept("./appAccordion.vue?vue&type=template&id=a670e22a&scoped=true&", function () {
      api.rerender('a670e22a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/components/ui/appAccordion/appAccordion.vue"
export default component.exports